import type { QuoteForm } from '#www/types'

type QuoteState = {
  contactEmail: boolean
  contactMessage: boolean
  contactPhone: boolean
  phone: string
} & QuoteForm

export default defineStore(
  'useQuoteStore',
  () => {
    const { $localePath } = useNuxtApp()

    const defaultQuoteState = () => {
      return {
        accompanimentId: null,
        accompanimentLanguages: [],
        approxDateFroms: [],
        approxDuration: undefined,
        budget: 0,
        comfortLevels: [],
        contactEmail: false,
        contactMessage: false,
        contactPhone: false,
        contacts: [],
        datesAreKnown: false,
        destinations: [],
        hasFlightTickets: false,
        phone: '',
        styleTypes: [],
        travelerTypes: [],
        tripId: null,
      }
    }
    const quoteState = ref<QuoteState>(defaultQuoteState())

    const redirectToAccount = async () =>
      await navigateTo($localePath({ name: 'account' }), { external: true })

    const storeQuote = async (redirect = true) => {
      await $fetch('/api/quotes', { method: 'POST' })

      if (!redirect) {
        return
      }

      await redirectToAccount()
    }

    const localePath = useLocalePath()

    const resetQuoteState = () => {
      quoteState.value = defaultQuoteState()
    }

    const newQuoteWithDestination = (destinationId: number) => {
      resetQuoteState()
      quoteState.value.destinations.push(destinationId)
      navigateTo(localePath({ name: 'quote-steps-01-destinations' }))
    }

    const newQuoteWithTrip = (tripId: number) => {
      resetQuoteState()
      quoteState.value.tripId = tripId
      navigateTo(localePath({ name: 'quote-steps-01-destinations' }))
    }

    return {
      newQuoteWithDestination,
      newQuoteWithTrip,
      quoteState,
      redirectToAccount,
      resetQuoteState,
      storeQuote,
    }
  },
  { persist: true },
)
